import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { CETELEM_POPUP_URL } from '~/const/3rd';

var PriceDiscount = function PriceDiscount() {
  return import('~/components/molecules/Product/PriceDiscount.vue');
};

var ProductLot = function ProductLot() {
  return import(
  /* webpackMode: "eager" */
  '~/components/atoms/Product/ProductLot.vue');
};

var EcoPartModal = function EcoPartModal() {
  return import(
  /* webpackMode: "eager"  */
  '~/components/molecules/Product/Modal/EcoPartModal.vue');
};

var Sequra = function Sequra() {
  return import(
  /* webpackMode: "eager" */
  '~/components/atoms/Product/Sequra.vue');
};

export default {
  name: 'ThePriceSection',
  components: {
    PriceDiscount: PriceDiscount,
    ProductLot: ProductLot,
    Sequra: Sequra
  },
  props: {
    price: {
      type: Object,
      required: true
    },
    loans: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    discountRate: {
      type: Number,
      default: null
    },
    isPrivateSales: {
      type: Boolean,
      default: false
    },
    priceType: {
      type: String,
      default: ''
    },
    lot: {
      type: Number,
      required: true
    },
    hasSequra: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      show20x: false,
      showModal: false,
      EcoPartModal: null
    };
  },
  computed: {
    cetelemPopupUrl: function cetelemPopupUrl() {
      return CETELEM_POPUP_URL;
    },
    cb: function cb() {
      if (!this.loans) return null;
      var filtredLoans = this.loans.filter(function (loan) {
        return loan.provider === 'CB';
      });
      return filtredLoans ? filtredLoans[0] : null;
    },
    cetelem: function cetelem() {
      return this.loans ? this.loans.filter(function (loan) {
        return loan.provider === 'CETELEM';
      }) : null;
    },
    sales: function sales() {
      var salesInfo = {
        hasDiscount: false
      };

      if (this.priceType === 'P' && this.discountRate && !this.isPrivateSales) {
        salesInfo = {
          hasDiscount: true,
          rate: parseFloat(this.discountRate, 10) || '',
          base: this.price.base.formatted || ''
        };
      } else if (process.client && this.$cookies.get('fpe_sales')) {
        salesInfo = {
          hasDiscount: true,
          rate: parseFloat(this.$cookies.get('fpe_sales'), 10),
          base: this.$cookies.get('fpe_sales')
        };
      }

      return salesInfo;
    },
    ecoPart: function ecoPart() {
      return this.$t('eco_part', {
        x: this.price.eco.formatted
      });
    },
    actualFormattedPrice: function actualFormattedPrice() {
      return this.price.sales.amount ? this.price.sales.formatted : this.price.base.formatted;
    },
    actualPrice: function actualPrice() {
      return this.price.sales.amount ? this.price.sales.amount : this.price.base.amount;
    }
  },
  methods: {
    openPopup: function openPopup(url) {
      window.open(url, 'Cetelem', 'height=700,width=800');
    },
    closeAction: function closeAction() {
      this.showModal = false;
    },
    showEcoPartModal: function showEcoPartModal() {
      this.EcoPartModal = EcoPartModal;
      this.showModal = true;
    },
    trackCredit: function trackCredit(event) {
      this.$root.$emit('generic-tracking', event, {
        fn: 'track-event',
        data: {
          event_category: 'FicheProduit',
          event_action: 'Clic_paiement_sans_frais',
          event_label: "".concat(window.tc_vars.page_cat1, "/").concat(window.tc_vars.page_cat2, "/").concat(window.tc_vars.page_cat3, "/").concat(window.tc_vars.page_cat4, "/").concat(window.tc_vars.page_cat5)
        }
      });
    }
  }
};